import { sharedConfig } from '@/pageConfig/shared';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LegalStuff/legalStuff__en-FR.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export type Config = BasePageConfig;

export const config: Config = {
  layout: { ...sharedConfig['en-US'].layout },
  seo: {
    ...sharedConfig['en-US'].seo,
    title: 'Lemonade FR: Legal',
    metaTitle: 'Lemonade FR: Legal',
    description:
      'Find all essential legal documents, consumer notices, and compliance information for Lemonade in France. Stay informed about your insurance rights.',
  },
  MDXContent: content as DocumentTypes,
};
